module.exports = __webpack_public_path__ + "img/anonymous.736c8b5c.png";